import React, { useState, useEffect, useRef } from 'react'
import { injectIntl } from 'react-intl'
import { useStyles } from './TechlinkJobShow_style'
import { Container, Box, Hidden } from '@material-ui/core'
import { ApplyProcessContext, useApplyProcessContext } from 'shared/contexts/ApplyProcessContext'
import TechlinkApplyButton from './components/TechlinkApplyButton/TechlinkApplyButton'
import TechlinkCompanyInfoCard from './components/TechlinkCompanyInfoCard/TechlinkCompanyInfoCard'
import TechlinkCompanyOtherJobs from './components/TechlinkCompanyOtherJobs/TechlinkCompanyOtherJobs'
import TechlinkJobPassport from './components/TechlinkJobPassport/TechlinkJobPassport'
import TechlinkJobShowBanner from './components/TechlinkJobShowBanner/TechlinkJobShowBanner'
import JobShowContent from 'pages/JobShow/components/JobShowContent/JobShowContent'
import JobShowMedia from 'pages/JobShow/components/JobShowMedia/JobShowMedia'
import ShowPageImages from 'components/ShowPageImages/ShowPageImages'
import VerticalVideos from 'components/VerticalVideos/VerticalVideos'
import TechlinkNavbar from '../TechlinkNavbar/TechlinkNavbar'

const TechlinkJobShow = (props) => {
    const { user, job, unavailable, altLangUrls } = props
    const { formatMessage } = props.intl
    const classes = useStyles()
    const applyProcessContext = useApplyProcessContext(props)
    const [, setCompanyImages] = useState([])
    const verticalVideosDivRef = useRef(null)
    const companyTechlinkUrl = `techlink/${formatMessage({ id: 'routes.companies' })}/${job.company_url}`

    useEffect(() => {
        if (job.type === 'student_job') {
            const shuffledImages = job.company_images.sort(() => 0.5 - Math.random())
            const selectedImages = shuffledImages.slice(0, 2)
            setCompanyImages(selectedImages)
        } else {
            setCompanyImages(job.company_images)
        }
    }, [])

    return (
        <>
            <TechlinkNavbar
                altLangUrls={altLangUrls}
                job={job}
            />
            <ApplyProcessContext.Provider value={applyProcessContext}>
                {/* ===== MODALS ===== */}
                <TechlinkJobShowBanner
                    user={user}
                    job={job}
                    unavailable={unavailable}
                    companyTechlinkUrl={companyTechlinkUrl}
                />
                <Hidden mdUp>
                    <Container maxWidth='lg' className={classes.mobileContainer} disableGutters>
                        {(!unavailable || job.current_user_is_job_owner) && <>
                            <JobShowMedia job={job} />
                            <Box className={classes.TechlinkjobPassportContainer}>
                                <TechlinkJobPassport
                                    job={job}
                                    unavailable={unavailable}
                                    user={user}
                                />
                            </Box>
                            <JobShowContent job={job} />
                            {((job.company_images && job.company_images.length > 0)) &&
                                <Box className={classes.marginBottomBox}>
                                    <ShowPageImages images={job.company_images} limit={3} companyName={job.company_name}/>
                                </Box>
                            }
                            <Box className={classes.applyButtonBox}>
                                <TechlinkApplyButton
                                    containerClass={classes.applyButtonContainer}
                                    buttonsClass={classes.applyButton}
                                    job={job}
                                    user={user}
                                />
                            </Box>
                        </>}
                    </Container>
                </Hidden>
                <Hidden smDown>
                    <Container maxWidth='lg' className={classes.desktopContainer} disableGutters>
                        {(!unavailable || job.current_user_is_job_owner) && <>
                            <Box className={classes.leftContainer}>
                                <TechlinkJobPassport
                                    job={job}
                                    unavailable={unavailable}
                                    user={user}
                                />
                                <TechlinkCompanyInfoCard job={job} companyTechlinkUrl={companyTechlinkUrl} />
                            </Box>
                            <Box className={classes.midContainer}>
                                <JobShowMedia job={job} />
                                <JobShowContent job={job} />
                                {job.we_offer !== '' && job.searched_profile !== '' &&
                                    <Box className={classes.applyButtonBox}>
                                        <TechlinkApplyButton
                                            containerClass={classes.applyButtonContainer}
                                            buttonsClass={classes.applyButton}
                                            job={job}
                                            user={user}
                                        />
                                    </Box>}
                                <Box ref={verticalVideosDivRef}>
                                    <VerticalVideos
                                        type='company'
                                        cardsNumber={2}
                                        companyId={job.company_self_or_parent_id}
                                    />
                                </Box>
                                {((job.company_images && job.company_images.length > 0)) &&
                                    <Box className={classes.marginBottomBox}>
                                        <ShowPageImages images={job.company_images} limit={6} companyName={job.company_name}/>
                                    </Box>
                                }
                                <TechlinkCompanyOtherJobs
                                    currentJobType={job.type}
                                    jobs={job?.company_jobs}
                                    companyName={job.company.name}
                                    companyTechlinkUrl={companyTechlinkUrl}
                                />
                            </Box>
                        </>}
                    </Container>
                </Hidden>
            </ApplyProcessContext.Provider>
        </>
    )
}

export default injectIntl(TechlinkJobShow)

TechlinkJobShow.defaultProps = {
    job: {
        logo: {
            cloudinary_key: 'qmicd21i4d1bgkqogpop'
        },
        company: {
            banner_image_id: 'goii6xdh52hvldjmd19m'
        }
    },
    defaultCloud: 'goii6xdh52hvldjmd19m'
}
